// extracted by mini-css-extract-plugin
module.exports =  {"vertical-nav-bar-container":"vertical-nav-bar-container-UPAkA","nav-tab-button":"nav-tab-button-tW6qT"};